// extracted by mini-css-extract-plugin
export var cartContainer = "_m0-4";
export var gray = "_m0-1";
export var itemContainer = "_m0-2";
export var itemDetails = "_m0-3";
export var strong = "_m0-0";